import Cookies from 'js-cookie'
import * as types from '../mutation-types';
import { getLanguage } from 'src/lang'
import _this from './../../main'
import { project_env } from 'src/config/config'

const state = {
    language: getLanguage()
}

const getters = {
    language: state => state.language
}

const mutations = {
    [types.SET_LANGUAGE]: (state, language) => {
        // 设置state、i18n、cookies
        state.language = language
        _this.$i18n.locale = language
        Cookies.set(project_env+'language', language)
    }
}

const actions = {
    setLanguage ({ commit }, language) {
        commit(types.SET_LANGUAGE, language)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/language.js